export default "__VITE_ASSET__BPq45UwR__"